// @flow
import { api, requestsGeneral } from 'app/api';

// import * as activityTypes from './activity-types';


// type ActivityType = $Values<typeof activityTypes>

const getActivitySubmitter = (/* activityType: ActivityType */) => async (uuid: string | null) => {
  if (!uuid) return;

  await api.request(requestsGeneral.Activity_POST, {
    requestPathParams: {
      uuid,
    },
  });
};

export default getActivitySubmitter;
